import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal'

import LoadingAlert from '../../../Alerts/LoadingAlert';
import Empty from '../../../utils/Empty';
import ErrorAlert from '../../../Alerts/ErrorAlert';
import { FaHistory } from 'react-icons/fa';
import { RenderIf } from '../../../utils/RenderIf';
import { MachinesFetchAPI } from '../../../../api/Machines';
import { CashTempPosFetchAPI } from '../../../../api/Paymentpost/OrderTemporalCash';
import { PrinterFetchAPI } from '../../../../api/Printer';
import { OrdersFetchAPI } from '../../../../api/Orders';
import { RequestLocalFetchAPI } from '../../../../api/Paymentpost/RequestLocal';
import { YappyFetchAPI } from '../../../../api/Paymentpost/Yappy';
import { generateToken } from '../../../../utils/GenerateToken';
import { buildCloudinaryImageUrl } from '../../../../utils/CloudinaryImageUrl';
import { normalizeApiError, showApiError } from '../../../../utils/ApiError';
import ModalPhoneSaveYappy from '../Yappy/ModalPhoneSaveYappy';
import ModalPaymentManual from '../../../PaymentPost/ModalPaymentManual';
import ModalYappyQrPos from '../../../PaymentPost/ModalYappyQrPos';
import Cashierpost from '../../../cahsier/Cashierpost';

import loading from '../../../PaymentPost/img/loading.gif'
import empty_img from '../../../PaymentPost/img/empty_pays.png';
import checkimg from '../../../PaymentPost/img/check.png';
import cancel from '../../../PaymentPost/img/cancel.png'
import sadImg from '../../../PaymentPost/img/sad.png'
import './ModalPaymentMixto.css'
import PayMethodsCarousel from '../PayMethodsCarousel';
const VOUCHER_SEPARATOR = "\r\n\r\n- - - - - - - - - - - - - - - - - - - -\r\n";

const safeJsonParse = (value, fallback = null) => {
    if (value == null || value === "" || value === "undefined") {
        return fallback;
    }

    try {
        return JSON.parse(value);
    } catch (err) {
        return fallback;
    }
}

const normalizeVoucherText = (voucherData) => {
    if (typeof voucherData === "string") {
        return voucherData;
    }

    if (voucherData && typeof voucherData === "object" && typeof voucherData.voucher === "string") {
        return voucherData.voucher;
    }

    return "";
}

const getStoredMixtoVoucher = () => {
    return normalizeVoucherText(safeJsonParse(localStorage.getItem('voucher_mixto'), ""));
}

const saveMixtoVoucher = (currentVoucher, nextVoucher) => {
    const currentText = normalizeVoucherText(currentVoucher);
    const nextText = normalizeVoucherText(nextVoucher);

    if (!nextText) {
        if (currentText) {
            localStorage.setItem('voucher_mixto', JSON.stringify({ voucher: currentText }));
        } else {
            localStorage.removeItem('voucher_mixto');
        }
        return { voucher: currentText };
    }

    const voucher = currentText ? `${currentText}${VOUCHER_SEPARATOR}${nextText}` : nextText;
    localStorage.setItem('voucher_mixto', JSON.stringify({ voucher }));
    return { voucher };
}



function ModalPaymentMixto({ showModalMixto, setShowModalMixto, paymentMethod, total, subtotal, discount, tax, orderNumber, formatDataOrder, registernewOrder, listPaymentReady,
    setlistPaymentReady, amountPaymentReady, setAmountPaymenReady, shoppingCart, amountPending, setAmountPending, change, setChange, yappy_transaction_id,
    setYappy_transaction_id, decimalReduction }) {
    const [paymentInfo, setPaymentInfo] = useState({ payment: "" })
    const [showModalAmount, setShowModalAmount] = useState(false)
    const [amountPayment, setAmountPayment] = useState(0)
    const [showModalProcess, setShowModalProcess] = useState(false);
    const [paymentApproval, setPaymentApproval] = useState({ status: 0, description: "Procesando pago" })
    const [tempMethodPayment, setTempMethodPayment] = useState(0)
    const [showModalPhone, setShowModalPhone] = useState(false);
    const [phoneClientYappy, setPhoneClientYappy] = useState("0");
    const [EMVStreamResponseMixto, setEMVStreamResponseMixto] = useState(0)
    //const [EMVStreamResponseMixto, setEMVStreamResponseMixto] = useState(0)
    //const [change, setChange] = useState(0);
    const [orderNumbeTemp, setOrderNumberTemp] = useState({ code: "", temp_id: "" })
    const [numberOrderMixto, setNumberOrderMixto] = useState("")
    const [showPaymentManual, setPaymentManual] = useState(false)

    //Yappy QR
    const [statePayment, setStatePayment] = useState(false);
    const [modalYappyQr, setModalYappyQr] = useState(false);
    const [dataYappy, setDataYappy] = useState({});
    const [dataHash, setDataHash] = useState("");
    const [statusRequestYappy, setStatusRequestYappy] = useState(false);

    let ventanaYappy = 0;
    let instervalCash = 0

    //cashier states
    const [modalShow, setModalShow] = useState(false);
    const [modalShowErrorRegisterOrder, setModalShowErrorRegisterOrder] = useState(false)
    const [detailOrder, setDetailOrder] = useState()
    const [amountOrder, setAmountOrder] = useState()

    //Functions to show and hide the modal cashier
    const handleCloseModal = () => setModalShow(false);
    const handleShowModal = () => setModalShow(true)



    //save info of payment
    const selectPayment = (e) => {
        if (e.target.checked == true) {
            let payment = JSON.parse(e.target.value)
            setPaymentInfo(payment)
        }
    }

    //next step phone number yappy
    const nextStepYappy = () => {
        setShowModalPhone(false)
        setShowModalProcess(true);

        //request c# yappy
        requestPyament(orderNumber);
        //createOrderCash("Yappy")
    }

    const statusCash = (status) => {
        if (status == 1) {//aprobed
            //function register payment

            let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
            let statusPaymentTurn = false;
            /*for (let i = 0; i < listPaymentReady.length; i++) {
                if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                    let newTotal = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                    listPaymentReady[i].total = newTotal.toFixed(2)
                    setlistPaymentReady(listPaymentReady)
                    statusPaymentTurn = true
                }
            }*/

            if (statusPaymentTurn == false) {
                localStorage.setItem('mixto_payment_approved', JSON.stringify({ "amountPaymentReady": newAmountReady, "amountPending": (parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)), "payments": [...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }] }))
                setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }]);
            }

            console.log(newAmountReady);
            setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
            setAmountPaymenReady(newAmountReady)

            setTimeout(() => {
                setAmountPayment(0)
                setShowModalProcess(false);
                setPaymentApproval({ status: 0, description: "Procesando pago..." })

            }, 1500);


            handleCloseModal()
        } else if (status == 2) {//cancel
            setShowModalProcess(false);
            handleCloseModal()
        }
    }

    //function process payment of the order
    const processPayment = async () => {

        if (parseFloat(amountPayment) > parseFloat(amountPending).toFixed(2)) {
            console.log("Ingresado: " + parseFloat(amountPayment));
            console.log("Pendiente: " + parseFloat(amountPending).toFixed(2));
            ErrorAlert("", "El valor ingresado supera el valor pendiente", "warning")
        } else {
            setShowModalProcess(true);
            setShowModalAmount(false)
            let title = 'Cargando....'
            let message = 'Cargando información....<br/> <br/>'
            let namePayment = paymentInfo.payment
            //-----------------------------------------------------
            //setBotonDeshabilitado(true);

            if (namePayment != "") {

                /*if (namePayment == 'PCCCOIN') {
                    setPaymentApproval({ status: 1, description: "APROBADO" });
                    let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
                    setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2) }]);
                    setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                    setAmountPaymenReady(newAmountReady)


                    setTimeout(() => {
                        setAmountPayment(0)
                        setShowModalProcess(false);
                        setPaymentApproval({ status: 0, description: "Procesando pago..." })

                    }, 3000);

                } else */if (namePayment == 'Efectivo' || namePayment == 'PCCCOIN') {
                    title = 'Esperando aprobacion....'
                    message = 'El administrador esta aprobando el pago....<br/> <br/>'
                    //LoadingAlert(title, message)
                    //createOrderCash("Efectivo")

                    //show cash modal
                    setDetailOrder({ total: parseFloat(amountPayment), code: "0000" })
                    handleShowModal();
                } else if (namePayment == 'Yappy') {
                    setShowModalPhone(true)
                    //setChange(0);
                } else if (namePayment == 'Yappy QR') {

                    GenerateYappyTransaction()
                } else if (namePayment == 'Credito') {
                    aprovedManualPaymentacardMixto("Aprobado", "Pago con credito")
                } else {

                    if (paymentInfo.integration.id == 1) {
                        console.log("integracion con bac")
                        requestPyament();
                    } else if (paymentInfo.integration.id == 3) {
                        console.log("metodo de pago manual")
                        setPaymentManual(true)
                        setShowModalProcess(false);
                    }

                    //setChange(0);
                }

                setTimeout(() => {
                    setTempMethodPayment(1);
                }, 15000);
            } else {
                ErrorAlert("No hay metodo de pago.", "Selecciona un metodo de pago", "info");
                //setBotonDeshabilitado(false)
            }
        }
    }

    //genrate yappy transaction
    const GenerateYappyTransaction = async () => {
        if (statePayment == false) {
            setStatePayment(true)
            LoadingAlert()
            let token = localStorage.getItem('x-access-machine-token');
            let machine = JSON.parse(localStorage.getItem('machine'));
            let data = {
                "machine_id": machine.id,
                "total": decimalReduction(parseFloat(amountPayment)).toString(),
                "subtotal": decimalReduction(parseFloat(amountPayment)).toString(),
                "tax": "0",
                "discount": "0",
                "transaction_code": orderNumber,
                "description": "Smartpay - orden:" + orderNumber,
                "params": paymentInfo.params
            }
            try {
                const response = await YappyFetchAPI.newYappyQr(data, token)
                setStatePayment(false)
                ErrorAlert("", "Todo listo para que realices el pago", "info")
                setDataYappy(response.data);
                setYappy_transaction_id(response.data.yappy_transaction.body.transactionId)
                setDataHash(response.data.yappy_transaction.body.hash)
                setModalYappyQr(true)
                setStatusRequestYappy(true)
                //getYappyTransaction(response.data)

            } catch (err) {
                setStatePayment(false)
                showApiError(err, {
                    title: "Yappy no esta disponible",
                    message: "No se pudo generar la transaccion Yappy.",
                    context: `order=${orderNumber} amount=${amountPayment}`,
                    icon: "warning",
                }, ErrorAlert)
            }
        } else {
            console.log("peticion en proceso");
        }
    }

    //create order cash temporal
    let type = 0
    const createOrderCash = async (type_method) => {
        let token = localStorage.getItem('x-access-machine-token');
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let machine = JSON.parse(localStorage.getItem('machine'))
        type = 0
        let json = {
            "client_name": "Estimado cliente",
            "localizador": "",
            "client_phone": "",
            "dgi_qr": "",
            "Orden": shoppingCart,
            "Descuento": 0.00,
            "Total": amountPayment,
            "itbms": 0.00,
            "subtotal": amountPayment,
            "machine_id": machine.id,
            "branchoffice_id": branchoffice.id,
            "tipoOrden": "comer aqui",
            "paymethod": paymentInfo.id,
            "is_discount_notification": false,
            "type_method": type_method,
            "transaction_code": orderNumber
        }

        try {
            const response = await CashTempPosFetchAPI.createTempCash(json, token)

            if (type_method == "Yappy") {
                console.log(response.data.newTempOrder._id);
                requestPyament(response.data.newTempOrder.code);
                setOrderNumberTemp({ code: response.data.newTempOrder.code, temp_id: response.data.newTempOrder._id })
            }

            console.log(response);
            getOrdersTempCash();
        } catch (err) {
            showApiError(err, {
                title: "No se pudo crear la orden temporal",
                message: "Se intentara recuperar una orden temporal existente.",
                context: `order=${orderNumber} payment=${type_method} amount=${amountPayment}`,
                icon: "warning",
            }, ErrorAlert)
            type = 1
            console.log("Hay una temporal");
            getOrdersTempCash();
        }
    }


    //get order temp cash
    let countGetCash = 0 // count to limit get orders
    const getOrdersTempCash = async () => {

        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let machine = JSON.parse(localStorage.getItem('machine'))
        let business = JSON.parse(localStorage.getItem('business'))
        clearInterval(instervalCash)
        try {
            const response = await CashTempPosFetchAPI.getTempCash(machine.code, business.code, branchoffice.code)
            console.log(response);
            let code = response.data.order.code
            let message = ""
            let title = ""
            let icon = ""

            if (type == 0) {
                if (countGetCash == 0) {
                    if (paymentInfo.payment != "Yappy") {
                        handleShowModal();
                    }
                    setDetailOrder(response.data.order);
                }

                if (response.data.order.status_id == 1) {
                    if (countGetCash <= 100) {
                        instervalCash = setInterval(getOrdersTempCash, 5000)
                        countGetCash++
                    } else {
                        message = "Tiempo de espera agotado"
                        title = "Advertencia"
                        icon = "warning"

                        if (paymentInfo.payment == "Yappy") {
                            ventanaYappy.close();
                            setPaymentApproval({ status: 3, description: "Tiempo de espera agotado." });
                        }
                        handleCloseModal()
                        updateOrderDiscount(code, 5, message, title, icon)
                        countGetCash = 0
                    }

                    //!Fixed Eroor: Correjir mensjae y  poner loading 
                } else if (response.data.order.status_id == 8) {//order temporal is cancel

                    title = "Operacion cancelada"
                    message = "Orden temporal cancelada"
                    icon = "error"

                    //setBotonDeshabilitado(false);

                    if (paymentInfo.payment == "Yappy") {
                        ventanaYappy.close();
                        setPaymentApproval({ status: 3, description: "Ocurrio un error." });
                    }
                    updateOrderDiscount(code, 5, message, title, icon)


                } else if (response.data.order.status_id == 7) {//order temporal is confirm
                    message = "El pago fue aprobado."
                    title = "Pago exitoso"
                    icon = "success"

                    if (paymentInfo.payment == "Yappy") {
                        ventanaYappy.close();
                        setPaymentApproval({ status: 1, description: "Pago exitoso." });
                    }

                    if (paymentInfo.payment == "Efectivo") {
                        //setShow(false)
                    }
                    updateOrderDiscount(code, 3, message, title, icon)

                    let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
                    let statusPaymentTurn = false;
                    /*for (let i = 0; i < listPaymentReady.length; i++) {
                        if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                            let newTotal = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                            listPaymentReady[i].total = newTotal.toFixed(2)
                            setlistPaymentReady(listPaymentReady)
                            statusPaymentTurn = true
                        }
                    }*/

                    if (statusPaymentTurn == false) {
                        localStorage.setItem('mixto_payment_approved', JSON.stringify({ "amountPaymentReady": newAmountReady, "amountPending": (parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)), "payments": [...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }] }))
                        setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }]);
                    }

                    console.log(newAmountReady);
                    setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                    setAmountPaymenReady(newAmountReady)

                    setTimeout(() => {
                        setAmountPayment(0)
                        setShowModalProcess(false);
                        setPaymentApproval({ status: 0, description: "Procesando pago..." })

                    }, 1500);

                }
            } else if (type == 1) {
                console.log("Consulte la temporal remanante");
                updateOrderDiscount(code, 5, message, title, icon)
            }
        } catch (err) {
            console.log(err);
        }
    }

    //update orders temporal discount
    const updateOrderDiscount = async (code, status, message, title, icon) => {
        console.log(code);
        let branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
        let business = JSON.parse(localStorage.getItem('business'))

        let jsonUpdate = {
            "order_code": code,
            "business_code": business.code,
            "branchoffice_code": branchoffice.code,
            "status": status
        }
        try {
            const response = await CashTempPosFetchAPI.updateOrderTempCash(jsonUpdate)
            console.log(paymentInfo.payment);

            if (type == 0) {
                if (paymentInfo.payment == "Yappy") {
                    setTimeout(() => {
                        setShowModalProcess(false);
                        setPaymentApproval({ status: 0, description: "Procesando pago..." });
                    }, 3000);
                }


                ErrorAlert(message, title, icon)


            } else if (type == 1) {
                console.log("Solicite crear nuevamente la temporal");
                createOrderCash(paymentInfo.payment)
            }
        } catch (err) {
            console.log(err);
        }

    }


    //function action request pyment local
    const requestPyament = async (yappy_Temp_id) => {
        setShowModalProcess(true);
        let JsonTr = {}

        if (paymentInfo.payment == "Yappy") {
            JsonTr = [{
                Tipo: 'SALE',
                Producto: 'COBRAR',
                Itbms: tax.toFixed(2),
                Descuento: discount.toFixed(2),
                Monto: parseFloat(amountPayment).toFixed(2),
                TipoVenta: paymentInfo.payment.toUpperCase(),
                paymentMethod: paymentInfo,
                orderid: yappy_Temp_id,
                tel: "507" + phoneClientYappy,
                total: parseFloat(amountPayment).toFixed(2),
                subtotal: parseFloat(amountPayment).toFixed(2),
                taxes: 0.00,
            }];
        } else {

            let methodPayment = ""
            if (paymentInfo.payment == "MasterCard") {
                methodPayment = "MC"
            } else {
                methodPayment = paymentInfo.payment
            }

            JsonTr = [{
                Tipo: 'SALE',
                Producto: 'COBRAR',
                Itbms: 0.00,
                Descuento: 0.00,
                Monto: parseFloat(amountPayment).toFixed(2),
                TipoVenta: methodPayment.toUpperCase(),
                paymentMethod: paymentInfo,
                orderid: orderNumber,
            }];

            let newToken = generateToken()
            JsonTr[0].SmartpayId = newToken
        }

        try {
            let machine = JSON.parse(localStorage.getItem('machine'))
            const response_machine = await MachinesFetchAPI.getmachineByid(machine.id, localStorage.getItem('x-access-machine-token'));
            const response = await RequestLocalFetchAPI.postPaymentMethod(JsonTr, response_machine.data.data.windows_ip);

            //setEMVStreamResponseMixto(response.data.data.EMVStreamResponse)

            const voucherMixto = saveMixtoVoucher(EMVStreamResponseMixto, response.data.data.EMVStreamResponse);
            setEMVStreamResponseMixto(voucherMixto);

            let responseCode = response.data.data.EMVStreamResponse.responseCode;
            let description = response.data.data.EMVStreamResponse.responseCodeDescription;



            function successPayment() {
                setPaymentApproval({ status: 1, description: description });
                let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
                let statusPaymentTurn = false;
                /*for (let i = 0; i < listPaymentReady.length; i++) {
                    if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                        listPaymentReady[i].total = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                        setlistPaymentReady(listPaymentReady)
                        statusPaymentTurn = true
                    }
                }*/

                if (statusPaymentTurn == false) {
                    // Respuesta cruda del datafono para ESTA pierna - necesaria para poder reversarla
                    // individualmente por su gateway si esta orden Mixta se devuelve completa.
                    const legVoucherResponse = JSON.stringify(response.data.data.EMVStreamResponse);
                    localStorage.setItem('mixto_payment_approved', JSON.stringify({ "amountPaymentReady": newAmountReady, "amountPending": (parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)), "payments": [...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id, voucher_response: legVoucherResponse }] }))
                    setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id, voucher_response: legVoucherResponse }]);
                }

                setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                setAmountPaymenReady(newAmountReady)
            }

            //condition
            console.log(response)
            if (paymentInfo.payment != "Yappy") {

                if (responseCode == "00") {
                    successPayment()
                } else {
                    setPaymentApproval({ status: 2, description: description });

                }

            } else {

                if (responseCode == "20") {
                    successPayment()
                } else {
                    setPaymentApproval({ status: 2, description: description });
                }

                {/*condition yappy temp
                if (response.data.data == "") {
                    setPaymentApproval({ status: 3, description: "Ocurrio un error." });

                } else {
                    ventanaYappy = window.open(response.data.data, "test", "");
                }*/}

            }

            setTimeout(() => {
                setAmountPayment(0)
                setShowModalProcess(false);
                setPaymentApproval({ status: 0, description: "Procesando pago..." })

            }, 3000);

        } catch (err) {
            setAmountPayment(0)
            const apiError = normalizeApiError(err, {
                title: "No se pudo procesar el pago mixto",
                message: "El metodo de pago no respondio correctamente.",
                context: `order=${orderNumber} payment=${paymentInfo.payment} amount=${amountPayment}`,
            });

            setPaymentApproval({ status: 3, description: apiError.message });
            showApiError(err, {
                title: apiError.title,
                message: apiError.message,
                context: `order=${orderNumber} payment=${paymentInfo.payment} amount=${amountPayment}`,
            }, ErrorAlert)

        }
    }

    //register payment aproved manual
    const aprovedManualPaymentacardMixto = (description, reference) => {

        const voucherMixto = saveMixtoVoucher(EMVStreamResponseMixto, reference);
        setEMVStreamResponseMixto(voucherMixto);

        setPaymentApproval({ status: 1, description: description });
        let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
        let statusPaymentTurn = false;
        /*for (let i = 0; i < listPaymentReady.length; i++) {
            if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                listPaymentReady[i].total = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                setlistPaymentReady(listPaymentReady)
                statusPaymentTurn = true
            }
        }*/

        if (statusPaymentTurn == false) {
            localStorage.setItem('mixto_payment_approved', JSON.stringify({ "amountPaymentReady": newAmountReady, "amountPending": (parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)), "payments": [...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }] }))
            setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id }]);
        }

        setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
        setAmountPaymenReady(newAmountReady)


        //---------------------------------------------------------------------------------
        setAmountPayment(0)
        setShowModalProcess(false);
        setPaymentApproval({ status: 0, description: "Procesando pago..." })

    }

    //cancel temporal transaction yappy
    const cancelTempYappy = () => {
        let message = "Orden temporal cancelada"
        let title = "Operacion cancelada"
        let icon = "error"
        updateOrderDiscount(orderNumbeTemp.code, 5, message, title, icon)
    }

    //cancel method payment in process
    const cancelMethodPayment = () => {
        setTempMethodPayment(0);
        setPaymentApproval({ status: 0, description: "Procesando pago..." })

        setShowModalProcess(false);
        {/*if (paymentInfo.payment == "Yappy") {
            let message = "Orden temporal cancelada"
            let title = "Operacion cancelada"
            let icon = "error"
            updateOrderDiscount(orderNumbeTemp.code, 5, message, title, icon)
        } else {
            setShowModalProcess(false);
        }*/}
    }

    //function try again yappy
    const try_again_yappy = () => {
        setPaymentApproval({ status: 0, description: "Procesando pago..." })
        requestPyament(orderNumbeTemp.temp_id);
    }


    //function action select payment
    const handlerPaymentStatus = () => {
        if (paymentInfo.payment != "") {

            if (paymentInfo.payment == "Efectivo" || paymentInfo.payment == "PCCCOIN") {

                //show cash modal
                setDetailOrder({ total: parseFloat(amountPayment), code: "0000" })
                handleShowModal();
            } else {
                setShowModalAmount(true)
            }

        } else {
            ErrorAlert("No hay metodo de pago.", "Selecciona un metodo de pago", "info");
        }
    }

    const hadleCancelYappy = (text) => {

        if (text != undefined) {
            setPaymentApproval({ status: 2, description: text });
        } else {
            setPaymentApproval({ status: 2, description: "CANCELADO" });
        }

        setYappy_transaction_id("")
        setModalYappyQr(false);
        setStatusRequestYappy(false)
        setAmountPayment(0)

        setTimeout(() => {
            setShowModalProcess(false);
            setPaymentInfo({ payment: "", payment_id: 0 })

            setPaymentApproval({ status: 0, description: "Procesando pago..." })
        }, 3000);
    }

    const getYappyTransaction = async () => {
        let token = localStorage.getItem('x-access-machine-token');

        try {
            let yappy_transaction_id = dataYappy.yappy_transaction.body.transactionId

            const response = await YappyFetchAPI.getYappyTransaction(yappy_transaction_id, token);

            let status = response.data.yappy_transaction.body.status;

            switch (status) {
                case 'PENDING':
                    //console.log("Transaccion pendiente");
                    break;

                case 'COMPLETED':
                    //console.log("Transaccion aprobada");

                    setModalYappyQr(false)
                    setStatusRequestYappy(false)
                    setPaymentApproval({ status: 1, description: "APROBADO" })

                    setTimeout(() => {

                        let newAmountReady = (parseFloat(amountPayment) + parseFloat(amountPaymentReady))
                        let statusPaymentTurn = false;
                        /*for (let i = 0; i < listPaymentReady.length; i++) {
                            if (listPaymentReady[i].paymethod_id == paymentInfo.payment_id) {
                                listPaymentReady[i].total = (parseFloat(listPaymentReady[i].total) + parseFloat(amountPayment))
                                setlistPaymentReady(listPaymentReady)
                                statusPaymentTurn = true
                            }
                        }*/

                        if (statusPaymentTurn == false) {
                            // yappy_transaction_id de ESTA pierna - necesario para poder reversarla
                            // individualmente si esta orden Mixta se devuelve completa.
                            const legVoucherResponse = JSON.stringify({ yappy_transaction_id });
                            localStorage.setItem('mixto_payment_approved', JSON.stringify({ "amountPaymentReady": newAmountReady, "amountPending": (parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)), "payments": [...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id, voucher_response: legVoucherResponse }] }))
                            setlistPaymentReady([...listPaymentReady, { name: paymentInfo.payment, paymethod_id: paymentInfo.payment_id, total: parseFloat(amountPayment).toFixed(2), paymenthod_integration_id: paymentInfo.integration_id, voucher_response: legVoucherResponse }]);
                        }

                        setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                        setAmountPaymenReady(newAmountReady)
                        setShowModalProcess(false);
                        setPaymentApproval({ status: 0, description: "Procesando pago..." })
                        setAmountPayment(0)
                    }, 3000);

                    break;

                case 'DECLINED':
                    setPaymentInfo({ payment: "" })
                    setDataHash("")
                    setYappy_transaction_id("")
                    hadleCancelYappy('DECLINED')

                    break;

                case 'EXPIRED':
                    setPaymentInfo({ payment: "" })
                    setDataHash("");
                    setYappy_transaction_id("")
                    hadleCancelYappy('EXPIRED')
                    break;

                case 'FAILED':
                    setPaymentInfo({ payment: "" })
                    setDataHash("")
                    setYappy_transaction_id("")
                    hadleCancelYappy('FAILED')
                    break;

                case 'VOIDED':
                    setPaymentInfo({ payment: "" })
                    setDataHash("")
                    setYappy_transaction_id("")
                    hadleCancelYappy('VOIDED')
                    break;

            }

        } catch (err) {
            console.log(err);
            setPaymentInfo({ payment: "" })
            setDataHash("")
            setYappy_transaction_id("")
            hadleCancelYappy("ERROR DE CONSULTA")
        }

    }


    useEffect(() => {
        let timer = 0
        if (statusRequestYappy == true) {
            timer = setInterval(async () => getYappyTransaction(), 5000); //INTERVAL GET YAPPY STATUS TRANSACTION

            return () => clearInterval(timer)
        } else {
            return () => clearInterval(timer) //CLEAR INTERVAL
        }

    }, [statusRequestYappy, dataYappy]);

    useEffect(() => {
        if (showModalMixto == true) {
            let mixto_payment_approved = safeJsonParse(localStorage.getItem('mixto_payment_approved'));
            if (mixto_payment_approved && Array.isArray(mixto_payment_approved.payments)) {
                setlistPaymentReady(mixto_payment_approved.payments);
                setEMVStreamResponseMixto({ voucher: getStoredMixtoVoucher() });

                let newAmountReady = 0;
                mixto_payment_approved.payments.forEach((payment) => {
                    newAmountReady += parseFloat(payment.total);
                });

                setAmountPending((parseFloat(total).toFixed(2) - parseFloat(newAmountReady).toFixed(2)))
                setAmountPaymenReady(newAmountReady)

                setTimeout(() => {
                    setAmountPayment(0)
                    setShowModalProcess(false);
                    setPaymentApproval({ status: 0, description: "Procesando pago..." })

                }, 3000);
            }
        }

    }, [showModalMixto]);


    return (
        <>

            <Modal

                show={showModalMixto}
                onHide={() => setShowModalMixto(false)}
                backdrop="static"
                centered

                // dialogClassName="sp-mx-dialog"
                contentClassName="sp-mx-content"
                fullscreen
            >
                <Modal.Body className="sp-mx">

                    {/* Header */}
                    <div className="sp-mx__head">
                        <div className="sp-mx__badge"><i className="uil uil-transaction"></i></div>
                        <h3 className="sp-mx__title">Pago mixto</h3>
                        <button className="sp-mx__x" type="button" aria-label="Cerrar" onClick={() => setShowModalMixto(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    {/* Cuerpo: 2 columnas */}
                    <div className="sp-mx__grid">

                        {/* Izquierda: métodos */}
                        <div className="sp-mx__col">
                            <span className="sp-mx__sectlabel">Seleccione un método de pago</span>
                            {!paymentMethod.length
                                ? <Empty title="Vacío" msg="No hay métodos de pago asignados" img={empty_img} />
                                : (

                                    <PayMethodsCarousel deps={paymentMethod.length}>
                                        <div className="sp-mx__methods">


                                            {paymentMethod.map(option => (
                                                option.payment != "Mixto" ? (

                                                    <div className="sp-mx__method" key={option.id}>
                                                        <input
                                                            type="radio"
                                                            className="sp-mx__radio"
                                                            name="option_payments"
                                                            id={option.id + "" + option.integration_id + "paymentMixto"}
                                                            value={JSON.stringify(option)}
                                                            onChange={(e) => (selectPayment(e))}
                                                        />
                                                        <label className="sp-mx__methodcard" htmlFor={option.id + "" + option.integration_id + "paymentMixto"}>
                                                            <span className="sp-mx__methodtick" aria-hidden="true">
                                                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><polyline points="20 6 9 17 4 12" /></svg>
                                                            </span>
                                                            <span className="sp-mx__methodimg">
                                                                <img loading="lazy" src={buildCloudinaryImageUrl({ url: option.img, width: 300, quality: "auto", type: "image" }) || empty_img} alt={option.payment} />
                                                            </span>
                                                            <span className="sp-mx__methodname">{option.payment}</span>
                                                            <span className="sp-mx__methodint">{option.integration.name}</span>
                                                        </label>
                                                    </div>




                                                ) : <React.Fragment key={option.id}></React.Fragment>
                                            ))}


                                        </div>
                                    </PayMethodsCarousel>
                                )}
                        </div>

                        {/* Derecha: resumen */}
                        <div className="sp-mx__col">
                            <div className="sp-mx__summary">
                                <div className="sp-mx__srow sp-mx__srow--total">
                                    <b>Total con impuesto:</b>
                                    <span translate="no">$ <strong>{total.toFixed(2)}</strong></span>
                                </div>

                                <div className="sp-mx__divider"></div>

                                {listPaymentReady.map((payment, idx) => (
                                    <div className="sp-mx__srow" key={idx}>
                                        <span>{payment.name}:</span>
                                        <span translate="no">$ <strong>{parseFloat(payment.total).toFixed(2)}</strong></span>
                                    </div>
                                ))}

                                <div className="sp-mx__srow sp-mx__srow--pending">
                                    <b>Saldo pendiente:</b>
                                    <span translate="no">$ <strong>{(amountPending).toFixed(2)}</strong></span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="sp-mx__foot">
                        <RenderIf isTrue={parseFloat(amountPending).toFixed(2) == 0.00}>
                            <button className="sp-mx__btn sp-mx__btn--ok" onClick={() => (formatDataOrder(EMVStreamResponseMixto, true), setShowModalMixto(false))}>
                                <i className="uil uil-check-circle"></i> Finalizar pago
                            </button>
                        </RenderIf>

                        <RenderIf isTrue={parseFloat(amountPending).toFixed(2) > 0.00}>
                            {listPaymentReady.length > 0 ? <></> : <>
                                <button className="sp-mx__btn sp-mx__btn--cancel" onClick={() => setShowModalMixto(false)}>Cancelar</button>
                            </>}
                            <button className="sp-mx__btn sp-mx__btn--primary" onClick={() => handlerPaymentStatus()}>
                                <i className="uil uil-usd-circle"></i> Realizar Pago
                            </button>
                        </RenderIf>
                    </div>

                </Modal.Body>
            </Modal >

            {/*Modal save amount payment select*/}

            <Modal
                show={showModalAmount}
                size="md"
                onHide={() => setShowModalAmount(false)}
                centered
                dialogClassName="sp-amt-dialog"
                contentClassName="sp-amt-content"
            >
                <Modal.Body className="sp-amt">

                    {/* Header */}
                    <div className="sp-amt__head">
                        {/* <div className="sp-amt__badge"><i className="uil uil-dollar-alt"></i></div> */}
                        <div className="sp-amt__headinfo">
                            <span className="sp-amt__eyebrow">Método de pago</span>
                            <h4 className="sp-amt__title">{paymentInfo.payment}</h4>
                        </div>
                        <button className="sp-amt__x" type="button" aria-label="Cerrar" onClick={() => setShowModalAmount(false)}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
                        </button>
                    </div>

                    {/* Input de monto */}
                    <div className="sp-amt__field">
                        <label className="sp-amt__label">Ingrese un monto</label>
                        <div className="sp-amt__inputwrap">
                            <span className="sp-amt__cur">$</span>
                            <input
                                type="number"
                                className="sp-amt__input"
                                placeholder="0.00"
                                onChange={(e) => (setAmountPayment(e.target.value))}
                            />
                        </div>
                    </div>

                    {/* Detalle */}
                    <div className="sp-amt__detail">
                        <span className="sp-amt__detailtitle">Detalle</span>
                        <div className="sp-amt__row is-danger">
                            <span>Saldo pendiente</span>
                            <span translate="no">$ <strong>{(amountPending).toFixed(2)}</strong></span>
                        </div>
                        <div className="sp-amt__row is-warning">
                            <span>Nuevo saldo</span>
                            <span translate="no">$ <strong>{amountPayment != "" && amountPayment != null && amountPayment != undefined ? <>{(amountPending - amountPayment).toFixed(2)}</> : <>{amountPending.toFixed(2)}</>}</strong></span>
                        </div>
                        <div className="sp-amt__row sp-amt__row--total">
                            <span>Total a pagar</span>
                            <span translate="no">$ <strong>{total.toFixed(2)}</strong></span>
                        </div>
                    </div>

                    {/* Footer */}
                    <div className="sp-amt__foot">
                        <button className="sp-amt__btn sp-amt__btn--cancel" onClick={() => setShowModalAmount(false)}>Cancelar</button>
                        <button className="sp-amt__btn sp-amt__btn--ok" onClick={async () => (processPayment())}>
                            <i className="uil uil-check"></i> Aplicar
                        </button>
                    </div>

                </Modal.Body>
            </Modal>


            {/*Process payment Loading Modal */}
            < Modal
                size='md-down'
                show={showModalProcess}
                centered
            >

            
                <div className="" >
                    <main className="">
                        <section className="sp-proc__card">

                            {/* Procesando */}
                            <RenderIf isTrue={paymentApproval.status == 0}>
                                <span className="sp-proc__badge is-muted">Método de Pago: {paymentInfo.payment}</span>
                                <div className="sp-proc__body">
                                    <div className="sp-proc__spinner"><img src={loading} width="90" height="90" alt="" /></div>
                                    <h2 className="sp-proc__title">{paymentApproval.description}</h2>
                                    {tempMethodPayment == 1 ? (
                                        <button className="sp-proc__btn sp-proc__btn--cancel" onClick={() => cancelMethodPayment()}>Cancelar</button>
                                    ) : ""}
                                </div>
                            </RenderIf>

                            {/* Éxito */}
                            <RenderIf isTrue={paymentApproval.status == 1}>
                                <span className="sp-proc__badge is-ok">Método de Pago: {paymentInfo.payment}</span>
                                <div className="sp-proc__body">
                                    <div className="sp-proc__icon is-ok"><img src={checkimg} width="90" height="90" alt="" /></div>
                                    <h2 className="sp-proc__title">¡Éxito!</h2>
                                    <p className="sp-proc__msg">Su pago ha sido procesado correctamente.</p>
                                </div>
                            </RenderIf>

                            {/* Cancelado / rechazado */}
                            <RenderIf isTrue={paymentApproval.status == 2}>
                                <span className="sp-proc__badge is-danger">Método de Pago: {paymentInfo.payment}</span>
                                <div className="sp-proc__body">
                                    <div className="sp-proc__icon is-danger"><img src={cancel} width="90" height="90" alt="" /></div>
                                    <h2 className="sp-proc__title">{paymentApproval.description}</h2>
                                    <p className="sp-proc__msg">Por favor, verifique la información e intente nuevamente.</p>
                                </div>
                            </RenderIf>

                            {/* Error con reintento (Yappy) */}
                            <RenderIf isTrue={paymentApproval.status == 3}>
                                <span className="sp-proc__badge is-danger">Método de Pago: {paymentInfo.payment}</span>
                                <div className="sp-proc__body">
                                    <div className="sp-proc__icon is-danger"><img src={cancel} width="90" height="90" alt="" /></div>
                                    <h2 className="sp-proc__title">{paymentApproval.description}</h2>
                                    <p className="sp-proc__msg">Por favor, verifique la información e intente nuevamente.</p>
                                    <div className="sp-proc__acts">
                                        <button className="sp-proc__btn sp-proc__btn--ghost" onClick={() => (setShowModalProcess(false))}>Volver</button>
                                        <button className="sp-proc__btn sp-proc__btn--primary" onClick={() => (try_again_yappy())}>Intentar de nuevo</button>
                                    </div>
                                </div>
                            </RenderIf>

                        </section>
                    </main>
                </div>
            </Modal >


            {/*input phone client */}
            < ModalPhoneSaveYappy showModalPhone={showModalPhone} setShowModalPhone={setShowModalPhone} setPhoneClientYappy={setPhoneClientYappy} nextStepYappy={nextStepYappy} ></ModalPhoneSaveYappy >


            {/* Modal cashier */}
            < Modal
                centered
                size='sm-down'
                show={modalShow}
                onHide={handleCloseModal} >
                <Modal.Header>

                    <div className='container'>
                        <div className='text-primary h4 bg-opacity-10 rounded'>
                            <div className='d-flex justify-content-between'>
                                <div className='px-1 mx-1' >
                                    Orden :  <span className='fw-bold'> {!orderNumber ? "0000" : orderNumber}</span></div>
                                <div className='px-1 mx-1' >
                                    Monto a pagar: <span className='fw-bold'> ${amountPending.toFixed(2)} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Cashierpost setChange={setChange} setAmountOrder={setAmountOrder} setOrderNumber={setNumberOrderMixto} setModalShow={setModalShow} order_data={detailOrder} statusCash={statusCash} paymentInfo={paymentInfo} mixto={true} setAmountPayment={setAmountPayment} amountPending={amountPending} amountPayment={amountPayment} total={total} />
                </Modal.Body>
            </Modal >

            {/*Modal payment manual*/}
            < ModalPaymentManual showPaymentManual={showPaymentManual} setPaymentManual={setPaymentManual} paymentInfo={paymentInfo} registernewOrder={registernewOrder} statusActivity={false} aprovedManualPaymentacardMixto={aprovedManualPaymentacardMixto} ></ModalPaymentManual >
            <ModalYappyQrPos modalYappyQr={modalYappyQr} setModalYappyQr={setModalYappyQr} dataYappy={dataYappy} setDataHash={setDataHash} setYappy_transaction_id={setYappy_transaction_id} dataHash={dataHash} hadleCancelYappy={hadleCancelYappy} total={parseFloat(amountPayment)} orderNumber={orderNumber} totaltopay={parseFloat(amountPayment)}></ModalYappyQrPos>




        </>
    )
}

export default ModalPaymentMixto
